import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/BreakdownReasonGroupActions";
import * as api from "../../api/BreakdownReasonGroupApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";


function* getBreakdownReasonGroupList() {
    try {
        const { data } = yield api.getBreakdownReasonGroupList();
        yield put(actions.setBreakdownReasonGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addBreakdownReasonGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addBreakdownReasonGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateBreakdownReasonGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateBreakdownReasonGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteBreakdownReasonGroup(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteBreakdownReasonGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_GROUP_LIST, getBreakdownReasonGroupList);
    yield takeEvery(actions.Types.ADD_BREAKDOWN_REASON_GROUP, addBreakdownReasonGroup);
    yield takeEvery(actions.Types.UPDATE_BREAKDOWN_REASON_GROUP, updateBreakdownReasonGroup);
    yield takeEvery(actions.Types.DELETE_BREAKDOWN_REASON_GROUP, deleteBreakdownReasonGroup);
}

const breakdownReasonGroupSaga = [fork(watchAll)];

export default breakdownReasonGroupSaga;
